import {Api, ApiExport} from '../../../Api.js'

const RESOURCE = 'campaign'

export default {
    resource: RESOURCE,
    export() {
        /*
        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.resource + '/export',
            method: 'GET',
            responseType: 'blob', // important
        });*/

        return ApiExport().get(this.resource + '/export',
            {
                responseType: 'blob', // important
            });

    },
    sendbox(data) {
        return Api().post(this.resource + '/sendbox', data)
    },
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    getStats(period, date = null) {

        if(date) {
            return Api().get(this.resource + '/stats?period=' + period + '&date=' + date);
        }

        return Api().get(this.resource + '/stats?period=' + period )
    },
}


// WEBPACK FOOTER //
// ./src/modules/campaign/campaign/CampaignService.js